export function HandleClientError(method: string, error: Error): void {
	const params = new URLSearchParams();

	console.log(error.message);
	
	params.append('method', method);
	params.append('name', error.name);
	params.append('message', error.message);
	params.append('stack', error.stack);

	window.location.replace(`/Home/ClientError?${params.toString()}`);
}
